<script>
export default {
  name: 'UserAuth',
  computed: {
    userId() {
      return this.userAuth.uid;
    },
    userName() {
      return this.userAuth.displayName;
    },
    userAvatar() {
      return this.userAuth.photoURL;
    },
    userMail() {
      return this.userAuth.email;
    },
    userAuth() {
      return this.$root.userAuth || {};
    },
    userMacInfo() {
      return this.$root.userMacInfo || {};
    },
    userDevice() {
      return this.$root.userDevice || {};
    },
    userTargetName() {
      return this.$root.userTargetName || {};
    },
    userCamera() {
      return this.$root.userCamera || {};
    },
    userFace() {
      return this.$root.userFace || {};
    },
    userScene() {
      return this.$root.userScene || {};
    },
    userMacro() {
      return this.$root.userMacro || {};
    },
    userMacroSchedule() {
      return this.$root.userMacroSchedule || {};
    },
    userContact() {
      return this.$root.userContact || {};
    },
    userSchedule() {
      return this.$root.userSchedule || {};
    },
    userKanban() {
      return this.$root.userKanban || {};
    },
    userTracker() {
      return this.$root.userTracker || {};
    },
    userLoading() {
      return !this.$root.userAuth;
    },
    sceneLoading() {
      return !this.$root.userScene;
    },
    macroLoading() {
      return !this.$root.userMacro;
    },
    contactLoading() {
      return !this.$root.userContact;
    },
    scheduleLoading() {
      return !this.$root.userSchedule;
    },
    deviceLoading() {
      return !this.$root.userDevice;
    },
    cameraLoading() {
      return !this.$root.userCamera;
    },
    faceLoading() {
      return !this.$root.userFace;
    },
    kanbanLoading() {
      return !this.$root.userKanban;
    },
    trackerLoading() {
      return !this.$root.userTracker;
    },
    macInfoLoading() {
      return !this.$root.userMacInfo;
    },
    searchGateway() {
      return this.$root.searchGateway;
    },
    searchKeyword() {
      return this.$root.searchKeyword;
    },
    searchFuncType() {
      return this.$root.searchFuncType;
    }
  },
  methods: {
    async refreshMac(mac) {
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          mac: mac,
          cmd: 'reload'
        });
      } catch (err) {
        this.toast(this.$t('gateway.permission_denied'));
        return;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/UserAuth.vue